export default __webpack_public_path__ + "static/media/w9-2025.0db7ceb3.png";